const navigateOnEnterOrSpace = callback => e => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    return callback(e);
  }
  return false;
};
export default navigateOnEnterOrSpace;
//# sourceMappingURL=navigateOnEnterOrSpace.js.map